export const updateTheme = (theme) => ({
  type: "UPDATE_THEME",
  theme,
});

export const setLanguage = (language) => ({
  type: "SET_LANG",
  language,
});

export const setProject = (project, user) => ({
  type: "SET_PROJECT",
  project,
  user,
});

export const setProjects = (projects) => ({
  type: "SET_PROJECTS",
  projects
})